import { useEffect } from "react";
import OFallonHeroSection from "./components/HeroSection";
import OFallonStickyNav from "./components/StickyNav";
import OFallonProcessingTimeSection from "./components/ProcessingTimeSection";
import OFallonServicesSection from "./components/ServicesSection";
import OFallonLocalAreaSection from "./components/LocalAreaSection";
import OFallonDestinationsSection from "./components/DestinationsSection";
import OFallonTestimonialsSection from "./components/TestimonialsSection";
import OFallonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OFallonComparisonSection from "./components/ComparisonSection";
import OFallonMistakesSection from "./components/MistakesSection";
import OFallonHowItWorksSection from "./components/HowItWorksSection";
import OFallonFAQSection, { faqs } from "./components/FAQSection";
import OFallonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import OFallonFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function OFallonPage() {
  useEffect(() => {
    document.title = "Emergency Passport O'Fallon, MO — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/ofallon-mo/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in O'Fallon, MO — as fast as 24 hours. Military families near Scott AFB, tech professionals, and St. Charles County families. A+ BBB rated, registered State Dept. courier. No drive to Downtown St. Louis required.");
    setMeta("geo.placename", "O'Fallon, Missouri");
    setMeta("geo.region", "US-MO");
    setMeta("geo.position", "38.8112;-90.6998");
    setMeta("ICBM", "38.8112, -90.6998");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Missouri", item: "https://fastpassportcenter.com/missouri/" },
          { "@type": "ListItem", position: 3, name: "O'Fallon Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Fast Passport Center provides emergency and expedited passport services for O'Fallon and St. Charles County. As fast as 24 hours — no drive to Downtown St. Louis required.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "O'Fallon", containedInPlace: { "@type": "State", name: "Missouri" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-ofallon";
    document.getElementById("structured-data-ofallon")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-ofallon")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <OFallonHeroSection />
      <OFallonStickyNav />
      <OFallonProcessingTimeSection />
      <OFallonServicesSection />
      <OFallonLocalAreaSection />
      <OFallonDestinationsSection />
      <OFallonTestimonialsSection />
      <OFallonAcceptanceFacilitiesSection />
      <OFallonComparisonSection />
      <OFallonMistakesSection />
      <OFallonHowItWorksSection />
      <OFallonFAQSection />
      <OFallonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/ofallon-mo" state="MO" />
      <OFallonFinalCTA />
    </div>
  );
}